import { render, staticRenderFns } from "./QuizResult.vue?vue&type=template&id=6a3dcb74&scoped=true&"
import script from "./QuizResult.vue?vue&type=script&lang=js&"
export * from "./QuizResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3dcb74",
  null
  
)

export default component.exports